import React from "react";
import {CircularProgress} from "@mui/material";
import cx from "classnames";
import "./Preloader.css";

const SIZE_DEFAULT = 40;

const Preloader = (props) => {
    const {
        isLoading, children, size, overflow,
    } = props;

    if (overflow && isLoading) {
        return (
            <div className={cx("PreloaderWrapper", {"PreloaderWrapper--active": isLoading})}>
                {children}
                {isLoading && (
                    <div className="PreloaderCircleBox">
                        <CircularProgress
                            className="Preloader"
                            size={size || SIZE_DEFAULT}
                        />
                    </div>
                )}
            </div>
        );
    }

    if (isLoading) {
        return (
            <CircularProgress
                className="Preloader"
                size={size || SIZE_DEFAULT}
            />
        );
    }

    return children;
};

export default Preloader;
